import { useDealer } from './useDealer';
import { useMemo } from 'react';

export type DealerStyles = {
  dealerMain: string;
  font: string;
  variableFontColor: string;
};

// somehow mui theming does not work for custom Colors
export const useDealerTheme = (): DealerStyles => {
  const dealer = useDealer();

  return useMemo(() => {
    switch (dealer) {
      case 'kraft':
        return {
          dealerMain: '#ff8100',
          font: 'latoHeavy,lato',
          variableFontColor: '#373737',
        };
      case 'scontode':
      case 'mahler':
        return {
          dealerMain: '#ea5045',
          font: 'sarabun',
          variableFontColor: '#373737',
        };
      case 'schrankwerkde':
        return {
          dealerMain: '#c7d32d',
          font: 'montserrat',
          variableFontColor: '#333333',
        };
      case 'DMK':
        return {
          dealerMain: '#8C9569',
          font: 'raleway',
          variableFontColor: '#333333',
        };
      case 'hoeffner':
      default:
        return {
          dealerMain: '#e2001a',
          font: 'montserrat',
          variableFontColor: '#274859',
        };
    }
  }, [dealer]);
};
